import { makeAutoObservable, runInAction } from 'mobx';
import { adminEmployeePositionsGetList } from '@/services/employeesApi';
import type { EmployeePosition } from '@/types/employee.types';
import { toastStore } from './ToastStore';

/**
 * Справочник должностей сотрудников сервисного центра.
 * Загружается один раз и кэшируется — своих должностей в этой задаче нет.
 */
class EmployeePositionsStore {
  positions: EmployeePosition[] = [];
  isLoading = false;
  private loadedForServiceCenterUuid: string | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  loadPositions = async (serviceCenterUuid: string) => {
    if (this.loadedForServiceCenterUuid === serviceCenterUuid && this.positions.length > 0) {
      return;
    }

    this.isLoading = true;
    try {
      const response = await adminEmployeePositionsGetList(serviceCenterUuid);
      runInAction(() => {
        this.positions = response.data ?? [];
        this.loadedForServiceCenterUuid = serviceCenterUuid;
        this.isLoading = false;
      });
    } catch {
      runInAction(() => {
        this.isLoading = false;
      });
      toastStore.showError('Не удалось загрузить список должностей');
    }
  };

  get options() {
    return this.positions
      .slice()
      .sort((a, b) => a.sort_order - b.sort_order)
      .map((position) => ({ value: position.uuid, label: position.name }));
  }
}

export const employeePositionsStore = new EmployeePositionsStore();
export type { EmployeePositionsStore };
